/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import "./intermediate-screen.styles.scss";

import dayjs from "dayjs";
import { ReactComponent as CheckedIcon } from "../../assets/checked.svg";
import CircleImage from "../../assets/circle.svg";
import plusIcon from "../../assets/Alarm-Plus-icon.png";
import minusIcon from "../../assets/minusIcon.png";

import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SyncOutlined,
} from "@ant-design/icons";

import { connect, useDispatch } from "react-redux";

import { createStructuredSelector } from "reselect";

import {
  selectBranches,
  selectSelectedCrop,
  selectCrops,
  selectVarieties,
  selectCurrentPage,
  selectViewAuctionPage,
  selectSelectedBranch,
  selectHubs,
  selectBranchParams,
} from "../../redux/common/common.selectors";

import {
  getSaudaDetails,
  putSaudaDetails,
  getMaterialCodes,
  getBagTypeDetails,
  putApproveSauda,
  putValidateVendor,
} from "../../services/auction-services";
import { getRebateMatrixService } from "../../services/common-services";

import { dataConstants, FeatureCodes } from "../../constants/data-constants";
import { canUserAccess } from "../../utils/utils";

import {
  Table,
  Form,
  message,
  Checkbox,
  Popover,
  Modal,
  Button,
  Select,
  Input,
  Alert,
  Row,
  Spin,
  Progress,
  Flex,
  Space,
  Col,
  Typography,
  Tooltip,
} from "antd";

import CustomFilter from "../../components/custom-filter/custom-filter.component";
import {
  selectAuthData,
  selectUserData,
} from "../../redux/user/user.selectors";

import Axios from "axios";
import { Dispatch } from "redux";
import {
  setSelectedBranch,
  setSelectedCrop,
} from "../../redux/common/common.actions";
import { TableProps } from "antd/lib";
import { useLocation } from "react-router";
const FileDownLoad = require("js-file-download");

const { Option } = Select;

const status = [
  { name: "Submission pending", id: 0 },
  { name: "Processing for SAP", id: 1 },
  // { name: "Approved", id: 2 },
  { name: "Sent to SAP", id: 3 },
  { name: "PO received from SAP", id: 4 },
  { name: "PO creation rejected by SAP", id: 5 },
];

const IntermediateScreen: React.FC = (props: any) => {
  const {
    branches,
    selectedCropId,
    crops,
    userData,
    currentpage,
    viewAuctionPage,
    selectedBranch,
    setSelectedBranchIndex,
    hubs,
    varietiesList,
    bagTypeData,
    conditionCodes,
    branchParams,
    authData,
  } = props;
  const dispatch = useDispatch();
  const [upcomingData, setUpcomingData] = useState<any>(); //[]
  const [isLoading, setIsLoading] = useState(false); //true
  const [isProgressClicked, setisProgressClicked] = useState(false);
  const [downloaddata, setdownloaddata] = useState<any>();
  const [isSpinnerOnProgress, setIsSpinnerOnProgress] = useState(false);
  const [rebateModalVisible, setRebateModalVisible] = useState(false);
  const [conditionsModalVisible, setConditionsModalVisible] = useState(false);
  const [rebateTableData, setRebateTableData] = useState<Array<any>>();
  const [selectConditions, setSelectConditions] = useState<any>(conditionCodes);
  const [clickedRowData, setClickedRowData] = useState<any>();
  const [modalValue, setModalValue] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [valueToEdit, setValueToEdit] = useState<any>();
  const [selectedVariety, setSelectedVariety] = useState();
  const [selectedDates, setSelectedDates] = useState([
    dayjs().format("YYYY-MM-DD"),
    dayjs().format("YYYY-MM-DD"),
  ]);
  const [selectedHub, setSelectedHub] = useState<any>();
  const [isTableVisible, setisTableVisible] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState<any>([0]);
  const [searchText, setSearchText] = useState("");
  const { TextArea } = Input;
  const location = useLocation();
  const columns = [
    {
      title: "Sauda ID",
      dataIndex: "saudhaId",
      key: "saudhaId",
      fixed: true,
    },
    {
      title: "Broker Sauda ID",
      dataIndex: "brokerSaudhaID",
      key: "brokerSaudhaID",
      fixed: true,
    },
    {
      title: "Vendor Code",
      dataIndex: "vendorCode",
      key: "vendorCode",
      fixed: true,
      render: (value: number, row: any) => {
        return (
          <div className={"select-remarks"}>
            <Input
              type="number"
              style={{
                verticalAlign: "middle",
                color: "black",
                width: 100,
                paddingRight: 0,
              }}
              maxLength={9}
              minLength={9}
              disabled={
                row.downloadStatus === 1 ||
                row.downloadStatus === 2 ||
                row.downloadStatus === 3 ||
                row.downloadStatus === 4 ||
                (row.downloadStatus === 5 && row.isParent === 1) ||
                !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
              }
              value={row.vendorCode}
              onChange={async (e) => {
                setVendorCode(
                  e.target.value,
                  row.varietyId,
                  row.saudhaId,
                  row.tempkey
                );
                if (
                  row.isBroker &&
                  row.downloadStatus === 5 &&
                  e.target.value.toString().length === 9
                ) {
                  try {
                    const response = await putValidateVendor({
                      saudha_id: row.saudhaId,
                      vendor_code: Number(e.target.value),
                    });
                    if (!response.data.data) {
                      message.error(
                        "Vendor Code must be unique and cannot be repeated..!",
                        3
                      );
                      setVendorCode(
                        "",
                        row.varietyId,
                        row.saudhaId,
                        row.tempkey
                      );
                    }
                  } catch (error) {
                    setVendorCode("", row.varietyId, row.saudhaId, row.tempkey);
                  }
                }
              }}
            />
          </div>
        );
      },
    },
    {
      title: "Firm Name",
      dataIndex: "userName",
      key: "user_name",
    },
    {
      title: "Broker Code",
      dataIndex: "brokerCode",
      key: "broker_code",
      render: (value: number, row: any) => {
        return (
          <div className={"select-remarks"}>
            <Input
              style={{
                verticalAlign: "middle",
                color: "black",
                width: 100,
                paddingRight: 0,
              }}
              maxLength={9}
              minLength={9}
              disabled={
                row.downloadStatus !== 0 ||
                row.isBroker ||
                row.isChild ||
                !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
              }
              value={row.brokerCode}
              onChange={(e) =>
                setBrokerCode(
                  e.target.value,
                  row.varietyId,
                  row.saudhaId,
                  row.tempkey
                )
              }
            />
          </div>
        );
      },
    },
    {
      title: "Broker Comment",
      dataIndex: "brokerRemark",
      key: "brokerRemark",
    },
    {
      title: "Hub",
      dataIndex: "hubName",
      key: "hub_name",
    },
    {
      title: "Variety",
      dataIndex: "varietyName",
      key: "variety_name",
    },
    {
      title: "Auction date",
      dataIndex: "auctionDate",
      key: "auction_date",
    },

    {
      title: `Allotted Qty (${
        crops?.find((item) => item.id == selectedCropId)?.unit || ""
      })`,
      dataIndex: "allotedQty",
      key: "allocatedqty",
      render: (value: number, row: any) => {
        return (
          <div className={"select-remarks"}>
            <Input
              type="number"
              style={{
                verticalAlign: "middle",
                color: "black",
                width: 50,
                paddingRight: 0,
              }}
              maxLength={35}
              min={0}
              disabled={
                row.downloadStatus !== 0 ||
                !row.isChild ||
                !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
              }
              value={row.allotedQty}
              onChange={(e) =>
                setAlottedQty(
                  e.target.value,
                  row.varietyId,
                  row.saudhaId,
                  row.tempkey
                )
              }
            />
          </div>
        );
      },
    },
    {
      title: `Price (₹/${
        crops?.find((item) => item.id == selectedCropId)?.unit
      })`,
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Brokerage Cost (₹)",
      dataIndex: "brokerageCost",
      key: "brokerageCost",
    },
    {
      title: "Rebate Name",
      dataIndex: "rebateName",
      key: "rebateName",
      render: (value: number, row: any) => {
        return (
          <div className={"rebate-info"}>
            {value}
            {value && (
              <span
                className="info"
                onClick={() => {
                  getRebateMatrix(row.rebateId, selectedBranch);
                }}
              >
                ?
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: "Crop Year",
      dataIndex: "cropYear",
      key: "cropYear",
      render: (value: number, row: any) => {
        return (
          <div className={"rebate-info-upcoming"}>
            <Select
              disabled={
                row.downloadStatus !== 0 ||
                row.isParent ||
                selectedCropId === 2 ||
                !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
              }
              style={{
                verticalAlign: "middle",
                color: "black",
              }}
              defaultValue={
                row.cropYear === 1 || row.cropYear === new Date().getFullYear()
                  ? new Date().getFullYear()
                  : new Date().getFullYear() - 1
              }
              onSelect={(value, props) =>
                setSelectedCropYear(
                  value,
                  row.varietyId,
                  row.saudhaId,
                  row.tempkey
                )
              }
            >
              {row.cropYearList &&
                row.cropYearList != undefined &&
                row.cropYearList.length &&
                row.cropYearList.map((bag: any, idx: number) => (
                  <Option key={bag.id} value={bag.val}>
                    {bag.val}
                  </Option>
                ))}
            </Select>
          </div>
        );
      },
    },
    {
      title: "Bag Type",
      dataIndex: "bagType",
      key: "bagType",
      render: (value: number, row: any) => {
        return (
          <div className={"rebate-info-upcoming"}>
            <Select
              value={row.bagId && `${row.bagId}`}
              disabled={
                row.downloadStatus !== 0 ||
                row.isParent ||
                !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
              }
              defaultValue={row.bagTypes[0].id}
              onSelect={(value) =>
                setSelectedBagType(
                  value,
                  row.varietyId,
                  row.saudhaId,
                  row.tempkey
                )
              }
              style={{
                width: "100%",
                fontWeight: row.isParent ? "bold" : "normal",
                color: row.isParent ? "gray" : "black",
              }}
            >
              {row.bagTypes &&
                row.bagTypes !== undefined &&
                row.bagTypes.length &&
                row.bagTypes.map((bag: any, idx: number) => (
                  <Option key={bag.id} value={bag.id}>
                    {bag.val}
                  </Option>
                ))}
            </Select>
          </div>
        );
      },
    },
    {
      title: "Material Code",
      key: "materialId",
      dataIndex: "materialId",
    },
    {
      title: "Remarks*",
      dataIndex: "remarks",
      key: "remarks",
      render: (value: any, row: any) => (
        <div className={"select-remarks"}>
          <TextArea
            autoSize={{ minRows: 0, maxRows: 2 }}
            style={{ verticalAlign: "middle", width: 90, paddingRight: 0 }}
            maxLength={300}
            disabled={
              (row.downloadStatus !== 0 && row.downloadStatus !== 5) ||
              row.isParent ||
              !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
            }
            value={row.remarks}
            onChange={(e) =>
              setRemarks(
                e.target.value,
                row.varietyId,
                row.saudhaId,
                row.tempkey
              )
            }
          />
        </div>
      ),
    },
    {
      title: "PO Number",
      dataIndex: "poNumber",
      key: "po_number",
      fixed: true,
      // width: 80,
      // ellipsis: true,
      render: (text) => (
        <Tooltip title={text}>
          <div
            style={{
              maxWidth: 80,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Add Broker",
      dataIndex: "addRow",
      fixed: true,
      key: "addRow",
      render: (actions, record) => (
        <div className="btn-container">
          {record.isBroker &&
            record.saudhaId !== null &&
            record.brokerSaudhaID === null && (
              <Button
                // style={{
                //   width: "25px",
                //   height: "25px",
                //   margin: "0px auto",
                //   visibility:
                //     record.isBroker &&
                //     record.saudhaId !== null &&
                //     record.brokerSaudhaID === null
                //       ? "visible"
                //       : "collapse",
                // }}
                icon={<PlusOutlined />}
                onClick={() => {
                  if (
                    record.downloadStatus === 0 &&
                    canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
                  ) {
                    setIsEdit(true);
                    setValueToEdit(record);
                    // handleAddRow(record, upcomingData.length);
                  }
                }}
              >
                Add
              </Button>
            )}
          {(record.isChild ||
            (record.saudhaId === null && record.brokerSaudhaID !== null)) && (
            <>
              <Button
                // style={{
                //   width: "25px",
                //   height: "25px",
                //   margin: "0px auto",
                //   visibility:
                //     record.isChild ||
                //     (record.saudhaId === null &&
                //       record.brokerSaudhaID !== null)
                //       ? "visible"
                //       : "collapse",
                // }}
                icon={<EditOutlined />}
                type="text"
                onClick={() => {
                  if (
                    record.downloadStatus !== 0 ||
                    canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
                  ) {
                    setIsEdit(true);
                    setValueToEdit(record);
                    // handleAddRow(record, upcomingData.length);
                  }
                }}
              />
              <Button
                icon={<DeleteOutlined />}
                danger
                type="text"
                onClick={() => {
                  if (
                    record.downloadStatus !== 0 ||
                    canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
                  )
                    handleDeleteRow(record);
                }}
              />
            </>
          )}
        </div>
      ),
    },
    {
      // title: (
      //   <div
      //     onClick={() => {
      //       canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER) &&
      //         onCheckBoxChange(upcomingData, "multi");
      //     }}
      //     className={`action-button
      // 								${
      //                   !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
      //                     ? "disable-field"
      //                     : ""
      //                 }`}
      //   >
      //     <Popover
      //       overlayClassName="competitor-hover-container"
      //       content={false}
      //       title={"Submit All"}
      //       style={{ width: "50px !important" }}
      //     >
      //       <img
      //         style={{
      //           // width: "10px",
      //           // height: "10px",
      //           margin: "0px auto",
      //         }}
      //         src={CircleImage}
      //         alt="Submit"
      //       />
      //     </Popover>
      //   </div>
      // ),
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (value: number, row: any) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {row.downloadStatus === 2 || row.downloadStatus === 0 ? (
              !row.isChild && (
                <Button
                  onClick={() => {
                    onCheckBoxChange([row], "single");
                  }}
                  disabled={
                    row.downloadStatus === 2 ||
                    row.isChild ||
                    canUserAccess(
                      userData,
                      FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
                    ) ||
                    !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
                  }
                  className={`action-button
									${
                    row.downloadStatus === 2 ||
                    row.isChild ||
                    !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
                      ? "disable-field"
                      : ""
                  }`}
                >
                  Submit
                  {/* <Popover
                  overlayClassName="competitor-hover-container"
                  content={false}
                  title={"Submit Sauda"}
                  style={{ width: "50px !important" }}
                >
                  <img
                    style={{
                      margin: "0px auto",
                    }}
                    src={CircleImage}
                    alt="Submit"
                  />
                </Popover> */}
                </Button>
              )
            ) : row.checked === false ? (
              // <div className={`action-submitted-button`}>
              //   <Popover
              //     overlayClassName="competitor-hover-container"
              //     content={false}
              //     title={"Sauda Submitted"}
              //     style={{ width: "50px !important" }}
              //   >
              //     <CheckedIcon />
              //   </Popover>
              // </div>
              <></>
            ) : (
              <Button
                onClick={() => {
                  canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER) &&
                    onCheckBoxChange([row], "single");
                }}
                type="primary"
                disabled={
                  !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER) ||
                  canUserAccess(userData, FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS)
                }
                className={`action-button
											${
                        row.downloadStatus === 2 ||
                        !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
                          ? "disable-field"
                          : ""
                      }`}
              >
                Submit
                {/* <Popover
                  overlayClassName="competitor-hover-container"
                  content={false}
                  title={"Submit Sauda"}
                  style={{ width: "50px !important" }}
                >
                  <img
                    style={{
                      margin: "0px auto",
                    }}
                    src={CircleImage}
                    alt="Submit"
                  />
                </Popover> */}
              </Button>
            )}
          </div>
        );
      },
    },
  ];
  const filteredData = useMemo(() => {
    if (!searchText) return upcomingData;

    return upcomingData.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [upcomingData, searchText]);
  const onCheckBoxChange = async (dataToPut: any, key: any) => {
    setIsLoading(true);
    let list: any = [];
    if (key === "multi") {
      dataToPut = dataToPut
        .map((element: any) => {
          if (
            element.downloadStatus !== 5 &&
            element.checked &&
            element.isParent !== true
          ) {
            // list.push(element);
            return element;
          } else return undefined;
        })
        .filter((item: any) => item !== undefined);
      upcomingData.forEach((obj2) => {
        if (
          dataToPut.some(
            (obj1) =>
              obj1.isChild === true &&
              obj2.isParent === true &&
              obj1.brokerSaudhaID === obj2.saudhaId
          )
        ) {
          dataToPut.push(obj2);
          // list.push(obj2);
        }
      });
      dataToPut = dataToPut.filter(
        (item: any) => item.isChild !== true && validateMulti([item], "single")
      );
      upcomingData.forEach((obj2) => {
        if (
          dataToPut.some(
            (obj1) =>
              (obj2.isChild === true &&
                obj1.isParent === true &&
                obj2.brokerSaudhaID === obj1.saudhaId) ||
              (obj2.saudhaId &&
                obj1.saudhaId &&
                obj2.saudhaId === obj1.saudhaId)
          )
        ) {
          list.push(obj2);
        }
      });
    } else if (key === "single" && dataToPut[0].isParent === true) {
      list = upcomingData.filter((item) => {
        if (
          item.brokerSaudaID !== null ||
          item.brokerSaudaID !== undefined ||
          item.brokerSaudaID !== ""
        ) {
          if (
            item.brokerSaudhaID === dataToPut[0].saudhaId ||
            item.saudhaId === dataToPut[0].saudhaId
          ) {
            return item;
          }
        }
      });
    } else {
      list = dataToPut;
    }

    if ((key === "multi" && list.length > 0) || validate(dataToPut, key)) {
      const reqBody = list.map((eachRow: any) => {
        const parentVendor = list.filter(
          (item) =>
            eachRow.isChild &&
            item.isParent &&
            eachRow.brokerSaudhaID === item.saudhaId
        );
        return {
          saudha_id: eachRow.saudhaId,
          bag_type: eachRow.bagId,
          remarks: eachRow.remarks,
          ...(eachRow.brokerCode || eachRow.isChild
            ? {
                conditions: [
                  {
                    condition_name: "Commission",
                    condition_type: "YCOA",
                    condition_value: eachRow.brokerage,
                    service_vendor_code:
                      eachRow.brokerCode ?? parentVendor[0].vendorCode,
                  },
                ],
              }
            : {}),
          material_code: eachRow.materialId,
          vendor_code: eachRow.vendorCode,
          broker_code: eachRow.brokerCode,
          broker_saudha_id: eachRow.brokerSaudhaID,
          YMM_ABD_CTRM_BUYING_MODEL: eachRow.buyingModel,
          YMM_ABD_CTRM_SALES_MODEL: eachRow.salesModel,
          YMM_ABD_CTRM_WH_TYPE: eachRow.whType,
          alloted_qty: eachRow.allotedQty,
          brokerage_cost: eachRow.brokerageCost ? eachRow.brokerageCost : 0,
          crop_year:
            eachRow.cropYear !== null
              ? String(eachRow.cropYear) === "2" ||
                String(eachRow.cropYear) ===
                  (new Date().getFullYear() - 1).toString()
                ? new Date().getFullYear() - 1
                : new Date().getFullYear()
              : new Date().getFullYear(),
        };
      });
      try {
        const response = await putSaudaDetails({ saudha_details: reqBody });
        if (response.data.status) {
          const listsauda = list
            .map((eachRow: any) => {
              return eachRow.saudhaId;
            })
            .filter((item) => item !== null);
          const reqBody1 = {
            saudha_id_list: listsauda,
          };
          const responseApprove = await putApproveSauda(reqBody1);
          if (responseApprove.data.status) {
            setUpcomingData([]);
            sessionStorage.setItem(
              "intermediateScreenTMParams",
              JSON.stringify({
                crop_id: selectedCropId,
                branch_id: selectedBranch,
                hub_id: selectedHub,
                variety_id: selectedVariety,
                start_date: selectedDates[0],
                end_date: selectedDates[1],
              })
            );
            // intermediateScreenDataSocketEmition(globalSocketData);
            const sevenPM = dayjs().hour(19).minute(0).second(0).millisecond(0);
            if (dayjs().isAfter(sevenPM)) setModalValue(true);
            getUpcomingData(
              selectedDates[0],
              selectedDates[1],
              selectedBranch,
              selectedVariety,
              selectedHub,
              selectedStatus
            );
          }
          message.success("Sauda submitted successfully", 2);
        } else {
          message.error("Something went wrong :(", 1);
          // setUpcomingData([]);
        }
        setIsLoading(false);
      } catch (error) {
        message.error("Something went wrong :(", 1);
        console.log(error);
        setIsLoading(false);
      }
    }
    // else {
    //   message.error("Enter valid details and select atleast one row.", 1)
    //   setIsLoading(false);
    // }
    setIsLoading(false);
  };

  const validate = (dataToPut: any, key: any) => {
    let retVal = true;
    var allotedVal = 0;
    if (
      dataToPut === null ||
      dataToPut === undefined ||
      dataToPut === "" ||
      dataToPut.length === 0
    ) {
      message.error("Enter valid details and select atleast one row.", 3);
      retVal = false;
    }

    if (key === "single" && dataToPut[0].isParent === true) {
      upcomingData.map((item) => {
        if (
          item.brokerSaudaID !== null ||
          item.brokerSaudaID !== undefined ||
          item.brokerSaudaID !== ""
        ) {
          if (item.brokerSaudhaID === dataToPut[0].saudhaId) {
            allotedVal =
              Number(allotedVal) +
              (item.allotedQty !== null &&
              item.allotedQty !== undefined &&
              item.allotedQty !== ""
                ? Number(item.allotedQty)
                : 0);
          }
        }
      });

      var list = upcomingData.filter((item) => {
        if (
          item.brokerSaudaID !== null ||
          item.brokerSaudaID !== undefined ||
          item.brokerSaudaID !== ""
        ) {
          if (item.brokerSaudhaID === dataToPut[0].saudhaId) {
            return item;
          }
        }
      });

      if (dataToPut[0].auctionDate != dayjs().format("YYYY-MM-DD")) {
        message.error("Submission Possible Only for Same Day Auctions...!", 3);
        setIsLoading(false);
        retVal = false;
      } else if (Number(allotedVal) !== dataToPut[0].allotedQty) {
        message.error(
          "Alloted bid quantity does not match the input quantity...!",
          3
        );
        setIsLoading(false);
        retVal = false;
      } else if (
        dataToPut[0].vendorCode.toString().length !== 9 ||
        !/^(11|13|15|23)/.test(dataToPut[0].vendorCode) ||
        /\D/.test(dataToPut[0].vendorCode)
      ) {
        message.error("Enter valid Vendor Code..!", 3);
        setIsLoading(false);
        retVal = false;
      } else {
        for (let i = 0; i < list.length; i++) {
          let eachRow = list[i];
          // if (
          //   eachRow.conditionId == null ||
          //   eachRow.conditionId == "" ||
          //   eachRow.conditionId == undefined
          // ) {
          //   message.error("Enter Conditions Code(s)..!", 1);
          //   setIsLoading(false);
          //   retVal = false;
          // }
          // else
          // const conditionData = eachRow.conditionCodes.filter(
          //   (item) =>
          //     item.service_vendor_code &&
          //     (item.service_vendor_code.toString().length !== 9 ||
          //       !/^(11|13|15|23)/.test(item.service_vendor_code) ||
          //       /\D/.test(item.service_vendor_code))
          // );
          // if (conditionData.length > 0) {
          //   message.error("Enter Valid Service vendor code", 3);
          //   setIsLoading(false);
          //   retVal = false;
          // }
          if (
            eachRow.vendorCode == null ||
            eachRow.vendorCode == "" ||
            eachRow.vendorCode == undefined
          ) {
            message.error("Select Vendor Code..!", 3);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.vendorCode.toString().length !== 9 ||
            !/^(11|13|15|23)/.test(eachRow.vendorCode) ||
            /\D/.test(eachRow.vendorCode)
          ) {
            message.error("Enter valid Vendor Code..!", 3);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.brokerCode &&
            (eachRow.brokerCode.toString().length !== 9 ||
              !/^(11|13|15|23)/.test(eachRow.brokerCode) ||
              /\D/.test(eachRow.brokerCode) ||
              eachRow.brokerCode == eachRow.vendorCode)
          ) {
            message.error("Enter valid Broker Vendor Code..!", 3);
            setIsLoading(false);
            retVal = false;
          } else if (
            (list.length > 1 &&
              upcomingData.filter(
                (obj) =>
                  (obj.saudhaId == eachRow.brokerSaudhaID ||
                    (obj.tempkey != eachRow.tempkey &&
                      obj.brokerSaudhaID == eachRow.brokerSaudhaID)) &&
                  obj.vendorCode == eachRow.vendorCode
              ).length > 0) ||
            dataToPut[0].vendorCode == eachRow.vendorCode
          ) {
            message.error(
              "Vendor Code must be unique and cannot be repeated..!",
              3
            );
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.allotedQty == null ||
            Number(eachRow.allotedQty) < Number(branchParams.minimum_quantity)
          ) {
            message.error(
              "Allocation quantity must not be lower than the Minimum Truckable Quantity.",
              3
            );
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.materialId == null ||
            eachRow.materialId == "" ||
            eachRow.materialId == undefined
          ) {
            message.error("Select Material Code..!", 3);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.remarks == null ||
            eachRow.remarks == "" ||
            eachRow.remarks == undefined
          ) {
            message.error("Enter remarks..!", 3);
            setIsLoading(false);
            retVal = false;
          }
          if (!retVal) {
            break;
          }
        }
      }
    } else {
      if (retVal === true) {
        for (let i = 0; i < dataToPut.length; i++) {
          let eachRow = dataToPut[i];
          // if (
          //   eachRow.conditionId == null ||
          //   eachRow.conditionId == "" ||
          //   eachRow.conditionId == undefined
          // ) {
          //   message.error("Enter Conditions Code(s)..!", 1);
          //   setIsLoading(false);
          //   retVal = false;
          // }
          // else
          // const condiitiondata = eachRow.conditionCodes.filter(
          //   (item) =>
          //     item.service_vendor_code &&
          //     (item.service_vendor_code.toString().length !== 9 ||
          //       !/^(11|13|15|23)/.test(item.service_vendor_code) ||
          //       /\D/.test(item.service_vendor_code))
          // );
          // if (condiitiondata.length > 0) {
          //   message.error("Enter Valid Service vendor code", 3);
          //   setIsLoading(false);
          //   retVal = false;
          // }
          if (eachRow.auctionDate != dayjs().format("YYYY-MM-DD")) {
            message.error(
              "Submission Possible Only for Same Day Auctions...!",
              3
            );
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.isBroker === true &&
            eachRow.brokerSaudhaID === null
          ) {
            message.error("Broker cannot allocate sauda to itself", 3);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.vendorCode == null ||
            eachRow.vendorCode == "" ||
            eachRow.vendorCode == undefined
          ) {
            message.error("Select Vendor Code..!", 2);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.vendorCode.toString().length !== 9 ||
            !/^(11|13|15|23)/.test(eachRow.vendorCode) ||
            /\D/.test(eachRow.vendorCode)
          ) {
            message.error("Enter valid Vendor Code..!", 2);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.brokerCode &&
            (eachRow.brokerCode.toString().length !== 9 ||
              !/^(11|13|15|23)/.test(eachRow.brokerCode) ||
              /\D/.test(eachRow.brokerCode) ||
              eachRow.brokerCode == eachRow.vendorCode)
          ) {
            message.error("Enter valid Broker Vendor Code..!", 2);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.materialId == null ||
            eachRow.materialId == "" ||
            eachRow.materialId == undefined
          ) {
            message.error("Select Material Code..!", 2);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.remarks == null ||
            eachRow.remarks == "" ||
            eachRow.remarks == undefined
          ) {
            message.error("Enter remarks..!", 2);
            setIsLoading(false);
            retVal = false;
          }
          if (!retVal) {
            break;
          }
        }
      }
    }
    // })
    return retVal;
  };
  const validateMulti = (dataToPut: any, key: any) => {
    let retVal = true;
    var allotedVal = 0;
    if (
      dataToPut === null ||
      dataToPut === undefined ||
      dataToPut === "" ||
      dataToPut.length === 0
    ) {
      message.error("Enter valid details and select atleast one row.", 3);
      retVal = false;
    }

    if (key === "single" && dataToPut[0].isParent === true) {
      upcomingData.map((item) => {
        if (
          item.brokerSaudaID !== null ||
          item.brokerSaudaID !== undefined ||
          item.brokerSaudaID !== ""
        ) {
          if (item.brokerSaudhaID === dataToPut[0].saudhaId) {
            allotedVal =
              Number(allotedVal) +
              (item.allotedQty !== null &&
              item.allotedQty !== undefined &&
              item.allotedQty !== ""
                ? Number(item.allotedQty)
                : 0);
          }
        }
      });

      var list = upcomingData.filter((item) => {
        if (
          item.brokerSaudaID !== null ||
          item.brokerSaudaID !== undefined ||
          item.brokerSaudaID !== ""
        ) {
          if (item.brokerSaudhaID === dataToPut[0].saudhaId) {
            return item;
          }
        }
      });
      if (dataToPut[0].auctionDate != dayjs().format("YYYY-MM-DD")) {
        // message.error("Auction Date not matched with current date...!", 3);
        setIsLoading(false);
        retVal = false;
      } else if (Number(allotedVal) !== dataToPut[0].allotedQty) {
        // message.error(
        //   "Modified allotted Qty should be equal to allotted qty.",
        //   1
        // );
        setIsLoading(false);
        retVal = false;
      } else if (
        dataToPut[0].vendorCode.toString().length !== 9 ||
        !/^(11|13|15|23)/.test(dataToPut[0].vendorCode) ||
        /\D/.test(dataToPut[0].vendorCode)
      ) {
        // message.error("Enter valid Vendor Code..!", 1);
        setIsLoading(false);
        retVal = false;
      } else {
        for (let i = 0; i < list.length; i++) {
          let eachRow = list[i];
          // if (
          //   eachRow.conditionId == null ||
          //   eachRow.conditionId == "" ||
          //   eachRow.conditionId == undefined
          // ) {
          //   message.error("Enter Conditions Code(s)..!", 1);
          //   setIsLoading(false);
          //   retVal = false;
          // }
          // else
          // const condiitiondata = eachRow.conditionCodes.filter(
          //   (item) =>
          //     item.service_vendor_code &&
          //     (item.service_vendor_code.toString().length !== 9 ||
          //       !/^(11|13|15|23)/.test(item.service_vendor_code) ||
          //       /\D/.test(item.service_vendor_code))
          // );
          // if (condiitiondata.length > 0) {
          //   // message.error("Enter Valid Service vendor code", 1);
          //   setIsLoading(false);
          //   retVal = false;
          // }
          if (
            eachRow.vendorCode == null ||
            eachRow.vendorCode == "" ||
            eachRow.vendorCode == undefined
          ) {
            // message.error("Select Vendor Code..!", 1);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.vendorCode.toString().length !== 9 ||
            !/^(11|13|15|23)/.test(eachRow.vendorCode) ||
            /\D/.test(eachRow.vendorCode)
          ) {
            // message.error("Enter valid Vendor Code..!", 1);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.brokerCode &&
            (eachRow.brokerCode.length !== 9 ||
              !/^(11|13|15|23)/.test(eachRow.brokerCode) ||
              /\D/.test(eachRow.brokerCode) ||
              eachRow.brokerCode == eachRow.vendorCode)
          ) {
            // message.error("Enter valid Broker Vendor Code..!", 1);
            setIsLoading(false);
            retVal = false;
          } else if (
            (list.length > 1 &&
              upcomingData.filter(
                (obj) =>
                  (obj.saudhaId == eachRow.brokerSaudhaID ||
                    (obj.tempkey != eachRow.tempkey &&
                      obj.brokerSaudhaID == eachRow.brokerSaudhaID)) &&
                  obj.vendorCode == eachRow.vendorCode
              ).length > 0) ||
            dataToPut[0].vendorCode == eachRow.vendorCode
          ) {
            // message.error("Broker and trader Vendor Code cannot same..!", 2);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.allotedQty == null ||
            Number(eachRow.allotedQty) < Number(branchParams.minimum_quantity)
          ) {
            // message.error(
            //   "Allocation quantity must not be lower than the Minimum Truckable Quantity.",
            //   1
            // );
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.materialId == null ||
            eachRow.materialId == "" ||
            eachRow.materialId == undefined
          ) {
            // message.error("Select Material Code..!", 1);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.remarks == null ||
            eachRow.remarks == "" ||
            eachRow.remarks == undefined
          ) {
            // message.error("Enter remarks..!", 1);
            setIsLoading(false);
            retVal = false;
          }
          // if (!retVal) {
          //   break;
          // }
        }
      }
    } else {
      if (retVal === true) {
        for (let i = 0; i < dataToPut.length; i++) {
          let eachRow = dataToPut[i];
          // if (
          //   eachRow.conditionId == null ||
          //   eachRow.conditionId == "" ||
          //   eachRow.conditionId == undefined
          // ) {
          // message.error("Enter Conditions Code(s)..!", 1);
          //   setIsLoading(false);
          //   retVal = false;
          // }
          // else
          // const condiitiondata = eachRow.conditionCodes.filter(
          //   (item) =>
          //     item.service_vendor_code &&
          //     (item.service_vendor_code.toString().length !== 9 ||
          //       !/^(11|13|15|23)/.test(item.service_vendor_code) ||
          //       /\D/.test(item.service_vendor_code))
          // );
          // if (condiitiondata.length > 0) {
          //   // message.error("Enter Valid Service vendor code", 1);
          //   setIsLoading(false);
          //   retVal = false;
          // }
          if (eachRow.auctionDate != dayjs().format("YYYY-MM-DD")) {
            // message.error("Auction Date not matched with current date...!", 3);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.isBroker === true &&
            eachRow.brokerSaudhaID === null
          ) {
            // message.error("Broker cannot allocate sauda to itself", 1);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.vendorCode == null ||
            eachRow.vendorCode == "" ||
            eachRow.vendorCode == undefined
          ) {
            // message.error("Select Vendor Code..!", 1);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.vendorCode.toString().length !== 9 ||
            !/^(11|13|15|23)/.test(eachRow.vendorCode) ||
            /\D/.test(eachRow.vendorCode)
          ) {
            // message.error("Enter valid Vendor Code..!", 1);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.brokerCode &&
            (eachRow.brokerCode.toString().length !== 9 ||
              !/^(11|13|15|23)/.test(eachRow.brokerCode) ||
              /\D/.test(eachRow.brokerCode) ||
              eachRow.brokerCode == eachRow.vendorCode)
          ) {
            // message.error("Enter valid Broker Vendor Code..!", 1);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.materialId == null ||
            eachRow.materialId == "" ||
            eachRow.materialId == undefined
          ) {
            // message.error("Select Material Code..!", 1);
            setIsLoading(false);
            retVal = false;
          } else if (
            eachRow.remarks == null ||
            eachRow.remarks == "" ||
            eachRow.remarks == undefined
          ) {
            // message.error("Enter remarks..!", 1);
            setIsLoading(false);
            retVal = false;
          }
          // if (!retVal) {
          //   break;
          // }
        }
      }
    }
    // })
    return retVal;
  };

  useEffect(() => {
    setSelectedVariety(undefined);
  }, [varietiesList]);

  /**
   *
   * @function
   * @description Establish socket.io connection for getting auction cards data.
   * @memberof App.MainLayout
   */
  // const intermediateScreenDataSocketEmition = (passedSocket) => {
  //   let socketCheck =
  //     globalSocketData !== undefined ? globalSocketData : passedSocket;
  //   let params = sessionStorage.getItem("intermediateScreenTMParams");
  //   params = params && JSON.parse(params);

  //   if (socketCheck) {
  //     if (params) {
  //       socketCheck.emit("im_screen_event", params);
  //     }

  //     // setIsLoading(true);
  //     socketCheck.on("im_screen", (data: any) => {
  //       const modifiedData = data.map((item: any, index: any) => {
  //         return {
  //           key: index,
  //           allotedQty: item.alloted_qty,
  //           hubName: item.hub_name,
  //           // saudaDate: item.sauda_date,
  //           // varietyName : item.variety_name,
  //           price: item.price,
  //           qty: item.qty,
  //           rebateId: item.rebate_id,
  //           rebateName: item.rebate_name,
  //           saudhaId: item.saudha_id,
  //           bidId: item.bid_id,
  //           downloadStatus: item.download_status,
  //           supplierId: item.supplier_id,
  //           userName: null,
  //           varietyId: item.variety_id,
  //           bagTypes: [
  //             { id: 1, val: "Old" },
  //             { id: 2, val: "New" },
  //             { id: 3, val: "PP" },
  //           ],
  //           bagId: item.bag_type === null ? 1 : item.bag_type,
  //           remarks: item.remarks,
  //           materialId: item.material_code,
  //           checked: false,
  //           charges: 0,
  //           isBroker: true, //TODO : chnge to item.role_id === 53? true:false,
  //           conditionCodes:
  //             item.conditions && item.conditions.length > 0
  //               ? item.conditions
  //               : conditionCodes,
  //           auctionDate: item.auction_date,
  //           vendorCode: item.vendorCode,
  //           varietyName: item.variety_name,
  //           cropYearList: [
  //             { id: 1, val: new Date().getFullYear() },
  //             { id: 2, val: new Date().getFullYear() - 1 },
  //           ],
  //           cropYear:
  //             item.crop_year === null
  //               ? new Date().getFullYear()
  //               : item.crop_Year,
  //           isParent: false,
  //           isChild: false,
  //           brokerSaudhaID: item.broker_saudha_id,
  //           auctionDivision: item.division,
  //         };
  //       });

  //       setUpcomingData(modifiedData);
  //       setIsLoading(false);
  //     });
  //   }
  // };

  // useEffect(() => {
  //   if (userData && userData.access_token && globalSocketData) {
  //     intermediateScreenDataSocketEmition(globalSocketData);
  //     intermediateScreenIntervalID = setInterval(() => {
  //       intermediateScreenDataSocketEmition(globalSocketData);
  //     }, 30000);
  //   }
  // }, [userData, globalSocketData]);

  useEffect(() => {
    // if (currentpage == "4" && viewAuctionPage == "40") {
    if (location.pathname.includes("/TN/intermediatesauda")) {
      // getConditionsData(selectedBranch);
      getUpcomingData(
        selectedDates[0],
        selectedDates[1],
        selectedBranch,
        selectedVariety,
        selectedHub,
        selectedStatus
      );
      // onBranchChange(selectedBranch, []);
      // setUpcomingData(upcomingData);
      // setMaterialCodesData(materialCode);
    }
  }, [
    authData.access_token,
    currentpage,
    viewAuctionPage,
    selectedDates,
    selectedBranch,
    selectedVariety,
    selectedStatus,
  ]);

  // useEffect(() => {
  //   getConditionsData();
  //   onBranchChange(branches[branchIndex].id, []);
  // }, [branchIndex]);

  // const onEditClicked = async (data: any) => {
  //   console.log(data);
  //   setValueToEdit({
  //     qty_rqd: data.qtyReqd,
  //     rebate_matrix_id: data.rebateId,
  //     auction_id: data.id,
  //     claim: data.claim,
  //   });

  //   setIsEdit(true);
  // };
  const setSelectedBagType = async (
    bagId: string,
    varietyId: number,
    saudaId: number,
    tempkey: number
  ) => {
    const modifiedData = upcomingData.map((item: any) => {
      if (item.saudhaId !== null) {
        if (item.saudhaId === saudaId && item.varietyId === varietyId) {
          return {
            ...item,
            bagId: bagId,
            checked: true,
          };
        } else {
          return item;
        }
      } else {
        if (item.tempkey === tempkey && item.varietyId === varietyId) {
          return {
            ...item,
            bagId: bagId,
            checked: true,
          };
        } else {
          return item;
        }
      }
    });
    setUpcomingData(modifiedData);
    // setMaterialCodesData(data);
  };

  const setSelectedCropYear = async (
    value: any,
    varietyId: number,
    saudaId: number,
    tempkey: number
  ) => {
    const modifiedData = upcomingData.map((item: any) => {
      if (item.saudhaId !== null) {
        if (item.saudhaId === saudaId && item.varietyId === varietyId) {
          return {
            ...item,
            cropYear: value,
          };
        } else {
          return item;
        }
      } else {
        if (item.tempkey === tempkey && item.varietyId === varietyId) {
          return {
            ...item,
            cropYear: value,
          };
        } else {
          return item;
        }
      }
    });
    setUpcomingData(modifiedData);
    // setMaterialCodesData(data);
  };

  const setSelectedMaterialCode = async (
    materialId: any,
    varietyId: number,
    saudaId: number,
    tempkey: number
    // rebateId: any,
    // rebateName: any
  ) => {
    const modifiedData = upcomingData.map((item: any) => {
      if (item.saudhaId !== null) {
        if (item.saudhaId === saudaId && item.varietyId === varietyId) {
          return {
            ...item,
            materialId: materialId,
            checked: true,
          };
        } else {
          return item;
        }
      } else {
        if (item.tempkey === tempkey && item.varietyId === varietyId) {
          return {
            ...item,
            materialId: materialId,
            checked: true,
          };
        } else {
          return item;
        }
      }
    });
    setUpcomingData(modifiedData);
  };
  const setSelectedConditionsDropDown = async (
    e: any,
    row: any,
    index: any,
    target: any,
    props: any
  ) => {
    // let modifiedData = [...upcomingData]
    let modifiedData = upcomingData;
    modifiedData = modifiedData.map((item: any) => {
      if (
        (item.saudhaId === null
          ? item.brokerSaudhaID === row.brokerSaudhaID
          : item.saudhaId === row.saudhaId) &&
        item.varietyId === row.varietyId
      ) {
        let a = item.conditionCodes;

        if (target === "condition_name") {
          a[index].condition_name = props.children[0];
          a[index].condition_type = e;
        }
        setSelectConditions(
          conditionCodes.filter(
            (rowItem) =>
              !item.conditionCodes.some(
                (conditionItem) =>
                  rowItem.condition_type === conditionItem.condition_type
              )
          )
        );
        row.conditionCodes = a;
        item.conditionCodes = a;
      }
      return item;
    });
    setClickedRowData(row);
    setUpcomingData(modifiedData);
  };

  const setOtherConditionChange = async (
    value: any,
    target: any,
    varietyId: number,
    saudaId: number,
    tempkey: number,
    rowData: any
  ) => {
    const modifiedData = upcomingData.map((item: any) => {
      if (item.saudhaId !== null) {
        if (item.saudhaId === saudaId && item.varietyId === varietyId) {
          if (target === "buyingModel") {
            rowData.buyingModel = value;
            return {
              ...item,
              buyingModel: value,
            };
          } else if (target === "salesModel") {
            rowData.salesModel = value;
            return {
              ...item,
              salesModel: value,
            };
          } else if (target === "whType") {
            rowData.whType = value;
            return {
              ...item,
              whType: value,
            };
          }
        } else {
          return item;
        }
      } else {
        if (item.tempkey === tempkey && item.varietyId === varietyId) {
          if (target === "buyingModel") {
            rowData.buyingModel = value;
            return {
              ...item,
              buyingModel: value,
            };
          } else if (target === "salesModel") {
            rowData.salesModel = value;
            return {
              ...item,
              salesModel: value,
            };
          } else if (target === "whType") {
            rowData.whType = value;
            return {
              ...item,
              whType: value,
            };
          }
        } else {
          return item;
        }
      }
    });
    setClickedRowData(rowData);
    setUpcomingData(modifiedData);
  };

  const setSelectedConditions = async (
    e: any,
    row: any,
    index: any,
    target: any,
    props: any
  ) => {
    let modifiedData = upcomingData;
    modifiedData = modifiedData.map((item: any) => {
      if (
        (item.saudhaId === null
          ? item.brokerSaudhaID === row.brokerSaudhaID
          : item.saudhaId === row.saudhaId) &&
        item.varietyId === row.varietyId &&
        Number(e.target.value) >= 0
      ) {
        let a = item.conditionCodes;
        if (target === "condition_value" && Number(e.target.value) >= 0) {
          a[index].condition_value = Number(e.target.value)
            ? Math.round(Number(e.target.value))
            : e.target.value;
        }

        if (target === "condition_name") {
          a[index].condition_name = e.target.value;
        }

        if (target === "service_vendor_code") {
          row.service_vendor_code =
            e.target.value === "" ? null : Number(e.target.value);
          a[index].service_vendor_code =
            e.target.value === "" ? null : Number(e.target.value);
        }
        row.conditionCodes = a;
        item.conditionCodes = a;
      }
      return item;
    });
    setClickedRowData(row);
    setUpcomingData(modifiedData);
  };

  const setRemarks = async (
    remarks: any,
    varietyId: number,
    saudaId: number,
    tempkey: number
  ) => {
    const modifiedData = upcomingData.map((item: any) => {
      if (item.saudhaId !== null) {
        if (item.saudhaId === saudaId && item.varietyId === varietyId) {
          return {
            ...item,
            remarks: remarks,
            checked: true,
          };
        } else {
          return item;
        }
      } else {
        if (item.tempkey === tempkey && item.varietyId === varietyId) {
          return {
            ...item,
            remarks: remarks,
            checked: true,
          };
        } else {
          return item;
        }
      }
    });
    setUpcomingData(modifiedData);
  };

  const setVendorCode = async (
    vendorcode: any,
    varietyId: number,
    saudaId: number,
    tempkey: number
  ) => {
    const modifiedData = upcomingData.map((item: any) => {
      if (item.saudhaId !== null) {
        if (item.saudhaId === saudaId && item.varietyId === varietyId) {
          return {
            ...item,
            vendorCode: vendorcode,
            checked: true,
          };
        } else {
          return item;
        }
      } else {
        if (item.tempkey === tempkey && item.varietyId === varietyId) {
          return {
            ...item,
            vendorCode: vendorcode,
            checked: true,
          };
        } else {
          return item;
        }
      }
    });
    setUpcomingData(modifiedData);
  };
  const setBrokerCode = async (
    brokerCode: any,
    varietyId: number,
    saudaId: number,
    tempkey: number
  ) => {
    const modifiedData = upcomingData.map((item: any) => {
      if (item.saudhaId !== null) {
        if (item.saudhaId === saudaId && item.varietyId === varietyId) {
          return {
            ...item,
            brokerCode: brokerCode,
            brokerageCost: brokerCode
              ? Number(item.allotedQty ?? 0) * Number(item.brokerage ?? 1)
              : "",
            checked: true,
          };
        } else {
          return item;
        }
      } else {
        if (item.tempkey === tempkey && item.varietyId === varietyId) {
          return {
            ...item,
            brokerCode: brokerCode,
            brokerageCost: brokerCode
              ? Number(item.allotedQty ?? 0) * Number(item.brokerage ?? 1)
              : "",
            checked: true,
          };
        } else {
          return item;
        }
      }
    });
    setUpcomingData(modifiedData);
  };

  const setAlottedQty = async (
    qty: any,
    varietyId: number,
    saudaId: number,
    tempkey: number
  ) => {
    const modifiedData = upcomingData.map((item: any) => {
      if (item.saudhaId !== null) {
        if (item.saudhaId === saudaId && item.varietyId === varietyId) {
          return {
            ...item,
            allotedQty: qty,
          };
        } else {
          return item;
        }
      } else {
        if (item.tempkey === tempkey && item.varietyId === varietyId) {
          return {
            ...item,
            allotedQty: qty,
            brokerageCost: Number(qty) * Number(item.brokerage ?? 1),
          };
        } else {
          return item;
        }
      }
    });
    setUpcomingData(modifiedData);
  };

  const handleConditionsClick = async (row: any) => {
    const conditionNamesInArray2 = row.conditionCodes.map(
      (obj) => obj.condition_name
    );
    const resultArray = conditionCodes.filter(
      (obj) => !conditionNamesInArray2.includes(obj.condition_name)
    );
    setSelectConditions(resultArray);
    setClickedRowData(row);
    setConditionsModalVisible(true);
  };

  const getMaterialData = async (
    varietyId: number,
    saudaId: number,
    auctionDivision: number,
    //rebateName: any,
    tempkey: number
    //rebateId: any
  ) => {
    setIsLoading(true);
    const params = {
      variety_id: varietyId,
      auction_division:
        auctionDivision == 1 ||
        Number(auctionDivision) === 1 ||
        String(auctionDivision) === "1"
          ? "ABD"
          : "FBD",
      // version: rebateName.split("_").pop(),
      // rebate_id: rebateName.replace(/_[0-9]+/, ''),
    };
    try {
      const response = await getMaterialCodes(params);
      if (response.data.status) {
        const data = response.data.data.map((item: any) => {
          return {
            key: item.material_no,
            id: item.material_no,
            value: item.material_code,
          };
        });
        const modifiedData = upcomingData.map((item: any) => {
          if (item.saudhaId !== null) {
            if (item.saudhaId === saudaId && item.varietyId === varietyId) {
              return {
                ...item,
                materialCode: data,
              };
            } else {
              return item;
            }
          } else {
            if (item.tempkey === tempkey && item.varietyId === varietyId) {
              return {
                ...item,
                materialCode: data,
              };
            } else {
              return item;
            }
          }
        });
        setUpcomingData(modifiedData);
        // setMaterialCodesData(data);
      } else {
        message.error("Something went wrong :(", 1);
        // setMaterialCodesData([]);
      }
      setIsLoading(false);
    } catch (error) {
      message.error("Something went wrong :(", 1);
      console.log(error);
      setIsLoading(false);
    }
  };

  const getUpcomingData = async (
    startDate: string,
    endDate: string,
    branchId: number,
    varietyID: any,
    hubId: any,
    status: any
  ) => {
    try {
      setIsLoading(true);
      const params = JSON.stringify({
        crop_id: selectedCropId,
        branch_id: branchId,
        hub_id: hubId ? (hubId.length ? hubId : undefined) : selectedHub,
        variety_id: varietyID,
        start_date: startDate,
        end_date: endDate,
        download_status:
          status.length === 0
            ? [0, 1, 3, 4, 5]
            : status && status.length
            ? status
            : [status],
      });
      const response = await getSaudaDetails(params);
      if (response.data.status && response.data.data !== undefined) {
        const data = response.data.data.map((item: any, index: any) => {
          return {
            key: index,
            allotedQty: item.alloted_qty,
            hubName: item.hub_name,
            price: item.price,
            qty: item.qty,
            brokerage: item.brokerage,
            brokerageCost: item.brokerage_cost
              ? item.brokerage_cost
              : item.role_id === 52
              ? Number(item.alloted_qty ?? 0) * Number(item.brokerage ?? 1)
              : "",
            rebateId: item.rebate_id,
            rebateName: item.rebate_name,
            saudhaId: item.saudha_id,
            bidId: item.bid_id,
            downloadStatus: item.download_status,
            supplierId: item.supplier_id,
            userName: item.user_name,
            varietyId: item.variety_id,
            bagTypes: bagTypeData,
            auctionDate: item.auction_date,
            vendorCode: item.vendor_code,
            varietyName: item.variety_name,
            brokerRemark: item.broker_bid_remark ? item.broker_bid_remark : "",
            cropYearList: [
              { id: 1, val: new Date().getFullYear() },
              { id: 2, val: new Date().getFullYear() - 1 },
            ],
            cropYear:
              item.crop_year === null
                ? 1
                : item.crop_year === new Date().getFullYear().toString()
                ? 1
                : 2,
            bagId: item.bag_type,
            remarks: item.remarks,
            materialId: item.material_code,
            checked: false,
            charges: 0,
            isParent: item.is_parent,
            isChild: false,
            brokerSaudhaID: item.broker_saudha_id,
            brokerCode: item.broker_code,
            poNumber: item.PO_number
              ? item.PO_number
              : item.sap_po_remark
              ? `Error: ${item.sap_po_remark}`
              : "",
            auctionDivision: item.division,
            isBroker: item.role_id === 52 ? true : false,
            buyingModel: item.YMM_ABD_CTRM_BUYING_MODEL,
            salesModel: item.YMM_ABD_CTRM_SALES_MODEL,
            whType: item.YMM_ABD_CTRM_WH_TYPE,
            conditionCodes: item.conditions,
          };
        });

        data.map((item) => {
          if (item && item.conditionCodes && item.conditionCodes.length < 5) {
            for (let i = item.conditionCodes.length; i < 5; i++) {
              item.conditionCodes.push({
                condition_name: "",
                condition_type: "",
                condition_value: null,
                service_vendor_code: null,
              });
            }
          }
        });
        setUpcomingData(data);
      } else {
        setUpcomingData([]);
      }
      setIsLoading(false);
    } catch (error) {
      // message.error("Something went wrong :(", 1);
      console.log(error);
      setIsLoading(false);
    }
  };

  const onBranchChange = async (value: string | number | any, option: any) => {
    setSelectedHub(undefined);
    setSelectedBranchIndex(value);
  };

  const getRebateMatrix = async (
    rebateId: string,
    branchId: number | undefined
  ) => {
    const params = {
      rebate_id: rebateId,
      branch_id: branchId,
      crop_id: selectedCropId,
    };
    try {
      const response = await getRebateMatrixService(params);
      if (response.data.status) {
        setRebateModalVisible(true);
        setRebateTableData(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const rebateColumns = [
    {
      title: "Head",
      dataIndex: "head",
      key: "head",
      render(_: any, row: any) {
        return {
          children: row.head,
          props: {
            rowSpan: row.rowSpan,
          },
        };
      },
    },
    {
      title: "Slab",
      dataIndex: "slab",
      key: "slab",
    },
    {
      title: "Rebate",
      dataIndex: "rate_display",
      key: "rate_display",
    },
  ];

  const createNewArr = (data: any) => {
    if (data)
      return data
        .reduce((result: any, item: any) => {
          //First, take the name field as a new array result
          if (result.indexOf(item.head) < 0) {
            result.push(item.head);
          }
          return result;
        }, [])
        .reduce((result: any, head: any) => {
          //Take the data with the same name as a new array, and add a new field * * rowSpan inside it**
          const children = data.filter((item: any) => item.head === head);
          result = result.concat(
            children.map((item: any, index: any) => ({
              ...item,
              rowSpan: index === 0 ? children.length : 0, //Add the first row of data to the rowSpan field
            }))
          );
          return result;
        }, []);
  };

  const onDateChange = (value: string | number | any, timeString: any) => {
    setSelectedDates(timeString);
    let start = dayjs(timeString[0]);
    let end = dayjs(timeString[1]);
    let differenceInDays = end.diff(start, "days");

    if (differenceInDays > 7) {
      setisTableVisible(true);
    } else {
      setisTableVisible(true);
    }
    getUpcomingData(
      timeString[0],
      timeString[1],
      selectedBranch,
      selectedVariety,
      selectedHub,
      selectedStatus
    );
  };

  const handleAddRow = async (row: any, length: any) => {
    setIsLoading(true);
    if (row.saudhaId != null) {
      var vaal, lengths;
      lengths = length;
      let modified = upcomingData.filter((item) => item.saudhaId === null);
      if (modified === null || modified.length <= 0) {
      } else {
        vaal = Math.max(...modified.map((o) => o.tempkey));
        lengths = vaal + 1;
      }
      const bagTypeResponse = await getBagTypeDetails();
      const item = {
        tempkey: lengths,
        allotedQtyData: "",
        conditionCodes: row.conditionCodes,
        hubName: row.hubName,
        price: row.price,
        qty: row.qty,
        brokerage: row.brokerage,
        brokerSaudhaID: row.saudhaId,
        rebateId: row.rebateId,
        rebateName: row.rebateName,
        saudhaId: null,
        bidId: row.bidId,
        downloadStatus: row.downloadStatus,
        supplierId: row.supplierId,
        userName: null,
        varietyId: row.varietyId,
        bagTypes: bagTypeResponse.data.data.reduce((prevState, currState) => {
          prevState.push({
            id: currState.parameter_data_value,
            val: currState.parameter_display_value,
          });
          return prevState;
        }, []),
        cropYearList: [
          { id: 1, val: new Date().getFullYear() },
          { id: 2, val: new Date().getFullYear() - 1 },
        ],

        isChild: true,
        cropYear: row.cropYear,
        bagId: row.bagId,
        materialId: row.materialId,
        checked: true,
        // checked: row.checked,
        charges: row.charges,
        auctionDate: row.auctionDate,
        isParent: false,
        auctionDivision: row.auctionDivision,
        vendorCodeData: "",
        vendorCode: row.vendorCode,
        varietyName: row.varietyName,
        isBroker: false,
        remarks: row.remarks,
        allotedQty: row.allotedQty,
        brokerageCost: Number(row.allotedQty) * Number(row.brokerage ?? 1),
        isEdit: true,
      };
      let modifiedDataa = upcomingData;
      modifiedDataa[row.key].isParent = true;
      const newData = modifiedDataa.slice(0); // copy

      newData.splice(upcomingData, row.key, item);

      let mdata = [
        ...modifiedDataa.slice(0, row.key + 1),
        item,
        ...modifiedDataa.slice(row.key + 1),
      ];

      mdata.map((item: any, index: any) => {
        item.key = index;

        return item;
      });
      setUpcomingData(mdata);
    } else {
      const mdata = upcomingData.map((item) => {
        return item.tempkey == row.tempkey ? row : item;
      });
      setUpcomingData(mdata);
    }

    setIsLoading(false);
    setisTableVisible(true);
  };

  const handleDeleteRow = async (row: any) => {
    var val = 0;
    var index1 = 0;

    const reducedArr = [...upcomingData];
    reducedArr.map((item: any, index: any) => {
      if (item.brokerSaudhaID === row.brokerSaudhaID) {
        // item.isParent = false;
        index1 = item.key;
        val = val + 1;
        isparent = false;
      }

      return item;
    });

    var isparent = true;
    reducedArr.splice(row.key, 1);

    reducedArr.map((item: any, index: any) => {
      item.key = index;
      return item;
    });

    if (val === 1) {
      reducedArr[index1 - 1].isParent = false;
    }

    setUpcomingData(reducedArr);
    isparent = true;
    val = 0;
  };
  const rowSelection: TableProps<any>["rowSelection"] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      // onCheckBoxChange(upcomingData, "multi");
    },
    getCheckboxProps: (record: any) => ({
      disabled: !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER), // Column configuration not to be checked
      id: record.key,
    }),
  };
  const fileDownload = async () => {
    setIsSpinnerOnProgress(true);
    const params = JSON.stringify({
      crop_id: selectedCropId,
      branch_id: selectedBranch,
      hub_id: selectedHub,
      variety_id: selectedVariety,
      start_date: selectedDates[0],
      end_date: selectedDates[1],
      download_status:
        selectedStatus.length === 0
          ? [0, 1, 3, 4, 5]
          : selectedStatus && selectedStatus.length
          ? selectedStatus
          : [0],
      download: true,
    });
    if (process.env.REACT_APP_ENV !== "production") {
      message.success(
        "Mail will send to your official email ID with the report."
      );
      setIsSpinnerOnProgress(false);
      return false;
    }
    Axios({
      url: dataConstants.SaudaDetailsUrl,
      method: "POST",
      data: params,
      responseType: "blob",
      onDownloadProgress: (progressEvent: any) => {
        let progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setdownloaddata(progress);
      },
    })
      .then((response: any) => {
        FileDownLoad(
          response.data,
          `Intermediate_sauda_${new Date().toLocaleDateString()}.xlsx`
        );
        message.success("File has been downloaded successfully!");
        setIsSpinnerOnProgress(false);
        setTimeout(
          function () {
            setisProgressClicked(false);
          }.bind(this),
          5000
        );
      })
      .catch((err: any) => {
        message.error("File cannot be downloaded");
        setIsSpinnerOnProgress(false);
        setisProgressClicked(false);
      });
  };
  return (
    <div className="intermediate-sauda">
      <Modal
        className="edit-im-modal"
        open={isEdit}
        onCancel={() => {
          setIsEdit(false);
          setValueToEdit({});
        }}
        footer={false}
        maskClosable={false}
      >
        {valueToEdit && (
          <Space direction="vertical">
            <Row gutter={[24, 16]}>
              <Col span={24}>
                <Typography.Title level={3}>
                  Add Broker Details
                </Typography.Title>
              </Col>
              <Col span={12}>
                <div className="label">Broker Sauda Id</div>
                <Input
                  value={valueToEdit.saudhaId}
                  type="text"
                  placeholder="Broker Sauda Id"
                  disabled
                />
              </Col>
              <Col span={12}>
                <div className="label help">Crop Year</div>
                <Select
                  disabled={
                    valueToEdit.downloadStatus !== 0 ||
                    valueToEdit.isParent ||
                    selectedCropId === 2 ||
                    !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
                  }
                  style={{
                    verticalAlign: "middle",
                    color: "black",
                    width: "100%",
                  }}
                  defaultValue={
                    valueToEdit.cropYear === 1 ||
                    valueToEdit.cropYear === new Date().getFullYear()
                      ? new Date().getFullYear()
                      : new Date().getFullYear() - 1
                  }
                  onSelect={(value, props) =>
                    setValueToEdit((prevState: any) => ({
                      ...prevState,
                      cropYear: value,
                    }))
                  }
                >
                  {valueToEdit.cropYearList &&
                    valueToEdit.cropYearList != undefined &&
                    valueToEdit.cropYearList.length &&
                    valueToEdit.cropYearList.map((bag: any, idx: number) => (
                      <Option key={bag.id} value={bag.val}>
                        {bag.val}
                      </Option>
                    ))}
                </Select>
              </Col>
              <Col span={12}>
                <div className="label">Vendor Code</div>
                <Input
                  type="number"
                  style={{ verticalAlign: "middle", color: "black" }}
                  maxLength={9}
                  minLength={9}
                  disabled={
                    valueToEdit.downloadStatus === 1 ||
                    valueToEdit.downloadStatus === 2 ||
                    valueToEdit.downloadStatus === 3 ||
                    valueToEdit.downloadStatus === 4 ||
                    (valueToEdit.downloadStatus === 5 &&
                      valueToEdit.isParent === 1) ||
                    !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
                  }
                  value={valueToEdit.vendorCode}
                  onChange={async (e) => {
                    setValueToEdit((prevState: any) => ({
                      ...prevState,
                      vendorCode: e.target.value,
                    }));
                    if (
                      valueToEdit.isBroker &&
                      valueToEdit.downloadStatus === 5 &&
                      e.target.value.toString().length === 9
                    ) {
                      try {
                        const response = await putValidateVendor({
                          saudha_id: valueToEdit.saudhaId,
                          vendor_code: Number(e.target.value),
                        });
                        if (!response.data.data) {
                          message.error(
                            "Vendor Code must be unique and cannot be repeated..!",
                            3
                          );
                          setValueToEdit((prevState: any) => ({
                            ...prevState,
                            vendorCode: "",
                          }));
                        }
                      } catch (error) {
                        setValueToEdit((prevState: any) => ({
                          ...prevState,
                          vendorCode: "",
                        }));
                      }
                    }
                  }}
                />
              </Col>
              <Col span={12}>
                <div className="label help">Bag Type</div>
                <Select
                  placeholder="Bag Type"
                  showSearch
                  filterOption={(inputValue, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(inputValue.toLowerCase()) >= 0
                  }
                  value={valueToEdit.bagId}
                  onChange={(value) =>
                    setValueToEdit((prevState: any) => ({
                      ...prevState,
                      bagId: value,
                    }))
                  }
                  style={{
                    width: "100%",
                  }}
                >
                  {valueToEdit.bagTypes &&
                    valueToEdit.bagTypes.map((item: any) => (
                      <Option value={item.id} id={item.id} key={item.id}>
                        {item.val}
                      </Option>
                    ))}
                </Select>
              </Col>
              <Col span={12}>
                <div className="label">
                  Alloted Qty (Total Qty - 100{" "}
                  {crops?.find((item) => item.id == selectedCropId)?.unit})
                </div>
                <Input
                  value={valueToEdit.allotedQty}
                  type="number"
                  placeholder="Alloted Qty"
                  onChange={(e) => {
                    setValueToEdit((prevState: any) => ({
                      ...prevState,
                      allotedQty: e.target.value,
                    }));
                  }}
                />
              </Col>
              <Col span={12}>
                <div className="label">Remarks</div>
                <Input
                  value={valueToEdit.remarks}
                  type="text"
                  placeholder="Remarks"
                  onChange={(e) => {
                    setValueToEdit((prevState: any) => ({
                      ...prevState,
                      remarks: e.target.value,
                    }));
                  }}
                />
              </Col>
            </Row>
            <div className="update-btn-container">
              <Button
                onClick={() => {
                  setIsEdit(false);
                  setValueToEdit({});
                }}
                danger
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  handleAddRow(valueToEdit, upcomingData.length);
                  setIsEdit(false);
                  setValueToEdit({});
                }}
                type="primary"
              >
                Save
              </Button>
            </div>
          </Space>
        )}
      </Modal>
      <Modal
        className="rebate-modal"
        open={rebateModalVisible}
        onCancel={() => setRebateModalVisible(false)}
        footer={false}
      >
        <div className="rebate-header">Rebate Matrix</div>
        <div className="rebate-container">
          <Table
            columns={rebateColumns}
            dataSource={createNewArr(rebateTableData)}
            pagination={false}
            scroll={{ y: window.innerHeight - 165 }}
          />
        </div>
      </Modal>
      <Modal
        className="temporal-modal"
        title="Alert!!!"
        open={modalValue}
        closable={true}
        maskClosable={false}
        okText="Ok"
        style={{ textAlign: "center" }}
        maskStyle={{ opacity: "1" }}
        centered
        okButtonProps={{
          style: { backgroundColor: "#20346a", border: 0 },
        }}
        cancelButtonProps={{ style: { display: "none" } }}
        onOk={() => setModalValue(false)}
      >
        <div style={{ color: "black" }}>
          SAP PO will not be generated from TradeNext after 7:25 PM. Please
          create the POs directly in the SAP system.
        </div>
      </Modal>

      <Modal
        footer={false}
        open={conditionsModalVisible}
        onCancel={() => {
          setConditionsModalVisible(false);
        }}
        className="submit-modal"
        width="max-content"
      >
        <div className="conditions-header" style={{ fontWeight: "normal" }}>
          Conditions
        </div>
        <div className="rebate-container">
          <div className="hub-form-container">
            <div className="form-top-container">
              <div className="row">
                <div
                  style={{
                    color: "#154479",
                    fontWeight: 500,
                    marginLeft: "8%",
                  }}
                >
                  TCD
                </div>
                <div
                  style={{
                    color: "#154479",
                    fontWeight: 500,
                    marginLeft: "12%",
                  }}
                >
                  Value
                </div>
                <div
                  style={{
                    color: "#154479",
                    fontWeight: 500,
                    marginRight: "3%",
                  }}
                >
                  Service Vendor Code
                </div>
              </div>
              {upcomingData &&
                clickedRowData &&
                upcomingData.length &&
                clickedRowData.conditionCodes
                  .filter((item, idx) => idx < 5)
                  .map((item: any, index: any) => {
                    for (let i = 0; i < 4; i++) {
                      return (
                        <>
                          <div className="row">
                            <div className="left">
                              <Select
                                style={{
                                  width: "220px",
                                  marginRight: "25px",
                                }}
                                className="select-year"
                                value={
                                  item.condition_type !== ""
                                    ? item.condition_name +
                                      " (" +
                                      item.condition_type +
                                      ")"
                                    : item.condition_name
                                }
                                onSelect={(value, props) => {
                                  setSelectedConditionsDropDown(
                                    value,
                                    clickedRowData,
                                    index,
                                    "condition_name",
                                    props
                                  );
                                }}
                              >
                                {selectConditions &&
                                  selectConditions !== undefined &&
                                  selectConditions.length &&
                                  selectConditions
                                    .filter(
                                      (item, idx) => item.condition_name !== ""
                                    )
                                    .map((bag: any, idx: number) => (
                                      <Option
                                        key={bag.condition_type}
                                        value={bag.condition_type}
                                      >
                                        {bag.condition_name} (
                                        {bag.condition_type})
                                      </Option>
                                    ))}
                              </Select>
                            </div>
                            <div className="middle">
                              <Input
                                type="number"
                                value={item.condition_value}
                                name="condition_value"
                                disabled={item.condition_type === ""}
                                onChange={(e) =>
                                  setSelectedConditions(
                                    e,
                                    clickedRowData,
                                    index,
                                    "condition_value",
                                    null
                                  )
                                }
                              />
                              <div className="unit">
                                INR (₹)/
                                {
                                  crops?.find(
                                    (item) => item.id == selectedCropId
                                  )?.unit
                                }
                              </div>
                            </div>
                            <div className="right">
                              <Input
                                type="text"
                                value={item.service_vendor_code}
                                name="service_vendor_code"
                                disabled={item.condition_value === null}
                                onChange={(e) =>
                                  setSelectedConditions(
                                    e,
                                    clickedRowData,
                                    index,
                                    "service_vendor_code",
                                    "service_vendor_code"
                                  )
                                }
                                maxLength={9}
                              />
                            </div>
                          </div>
                        </>
                      );
                    }
                  })}
            </div>
          </div>
        </div>
        {selectedCropId === 2 && clickedRowData !== undefined && (
          <div
            className="conditions-header"
            style={{ marginTop: 25, fontWeight: "normal" }}
          >
            Other Conditions
          </div>
        )}
        {selectedCropId === 2 && clickedRowData !== undefined && (
          <div className="rebate-container">
            <div className="hub-form-container">
              <div className="form-top-container">
                <div className="row">
                  <div
                    style={{
                      color: "#154479",
                      fontWeight: 500,
                      marginLeft: "8%",
                    }}
                  >
                    Conditions
                  </div>
                  <div
                    style={{
                      color: "#154479",
                      fontWeight: 500,
                      marginRight: "20%",
                    }}
                  >
                    Value
                  </div>
                </div>
                <div className="row">
                  <div className="left" style={{ width: "45%" }}>
                    YMM_ABD_CTRM_BUYING_MODEL
                  </div>
                  <div className="other-right">
                    <Input
                      type="text"
                      value={clickedRowData.buyingModel}
                      name="buyingModel"
                      onChange={(e) =>
                        setOtherConditionChange(
                          e.target.value,
                          e.target.name,
                          clickedRowData.varietyId,
                          clickedRowData.saudhaId,
                          clickedRowData.tempkey,
                          clickedRowData
                        )
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="left" style={{ width: "45%" }}>
                    YMM_ABD_CTRM_SALES_MODEL
                  </div>
                  <div className="other-right">
                    <Input
                      type="text"
                      value={clickedRowData.salesModel}
                      name="salesModel"
                      onChange={(e) =>
                        setOtherConditionChange(
                          e.target.value,
                          e.target.name,
                          clickedRowData.varietyId,
                          clickedRowData.saudhaId,
                          clickedRowData.tempkey,
                          clickedRowData
                        )
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="left" style={{ width: "45%" }}>
                    YMM_ABD_CTRM_WH_TYPE
                  </div>
                  <div className="other-right">
                    <Input
                      type="text"
                      value={clickedRowData.whType}
                      name="whType"
                      onChange={(e) =>
                        setOtherConditionChange(
                          e.target.value,
                          e.target.name,
                          clickedRowData.varietyId,
                          clickedRowData.saudhaId,
                          clickedRowData.tempkey,
                          clickedRowData
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>

      <Flex wrap gap={5}>
        <Input.Search
          placeholder="Search..."
          allowClear
          onSearch={setSearchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: "15em" }}
          variant="outlined"
        />
        <CustomFilter
          type="range-picker"
          head="Date Range"
          startDate={dayjs(selectedDates[0])}
          endDate={dayjs(selectedDates[1])}
          onChange={onDateChange}
        />
        <CustomFilter
          type="single-select"
          value={selectedBranch}
          options={branches}
          onChange={onBranchChange}
          placeholder="Select Branch"
          head="ITC Branch Office"
          returnId
        />
        <CustomFilter
          type="multi-select"
          value={selectedHub}
          options={hubs}
          onChange={(value: any) => {
            setSelectedHub(value);
            getUpcomingData(
              selectedDates[0],
              selectedDates[1],
              selectedBranch,
              selectedVariety,
              value,
              selectedStatus
            );
          }}
          placeholder="Select Hub"
          head="Hub"
          returnId
        />
        <CustomFilter
          type="single-select"
          value={selectedCropId}
          onChange={(value: any) => dispatch(setSelectedCrop(value))}
          options={crops}
          placeholder="Select Crops"
          head="crops"
          returnId
        />
        <CustomFilter
          type="multi-select"
          value={selectedVariety}
          onChange={(value: any) => setSelectedVariety(value)}
          options={varietiesList}
          placeholder="Select Variety"
          head="Variety"
          returnId
        />
        <CustomFilter
          type="multi-select"
          value={selectedStatus}
          options={status}
          onChange={(value: any) => setSelectedStatus(value)}
          placeholder="Select Status"
          className="status-filter-approval"
          head="Status"
          returnId
        />
        {/* <div className="selected-wheat">
          <span className="selected-wheat-label">Selected Crop</span> <br />
          <span className="selected-wheat-value">
            <b>
              {crops &&
                crops.length &&
                crops.find(
                  (item: { id: number; name: string }) =>
                    item.id == selectedCropId
                ).name}
            </b>
          </span>
        </div> */}
        <Button
          loading={isLoading}
          onClick={() => {
            canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER) &&
              onCheckBoxChange(upcomingData, "multi");
          }}
          disabled={canUserAccess(
            userData,
            FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
          )}
          className={`action-button
      								${
                        !canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER)
                          ? "disable-field"
                          : ""
                      }`}
        >
          Submit All
        </Button>
        {upcomingData?.length > 0 && (
          <Button
            onClick={() => {
              setdownloaddata(0);
              setisProgressClicked(true);
              fileDownload();
            }}
            // type="primary"
            // shape="round"
            // size="large"
            loading={isProgressClicked}
            className="download-btn-styles"
            disabled={canUserAccess(
              userData,
              FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
            )}
          >
            Download
          </Button>
        )}
        {isTableVisible && (
          <Button
            className="refreshButton"
            icon={<SyncOutlined spin={isLoading} />}
            onClick={() =>
              getUpcomingData(
                selectedDates[0],
                selectedDates[1],
                selectedBranch,
                selectedVariety,
                selectedHub,
                selectedStatus
              )
            }
          >
            Refresh
          </Button>
        )}
      </Flex>
      {isTableVisible ? (
        <div className="sauda-table-container" style={{ paddingTop: 10 }}>
          <Table
            loading={isLoading}
            columns={columns}
            dataSource={filteredData}
            // dataSource={upcomingData}
            pagination={false}
            // rowSelection={w{ type: "checkbox", ...rowSelection }}
            // scroll={{ x: "max-content" }}
            size="small"
            // tableLayout="auto"
            /* footer={() => {
            return upcomingData?.length ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  alignItems: "baseline",
                  gap: "1em",
                  position: "fixed",
                  right: "5px",
                }}
              >
                <div className="progress-download-container">
                  {isProgressClicked && (
                    <Progress
                      type="circle"
                      percent={downloaddata}
                      size={37}
                      strokeColor={{ "0%": "#108ee9", "100%": "#87d068" }}
                      style={{
                        right: "110px",
                        position: "absolute",
                        display: "flex",
                        marginTop: "-15px",
                      }}
                      trailColor="#003285"
                    />
                  )}
                </div>
                <div className="download-button-container">
                  {upcomingData?.length && (
                    <Button
                      onClick={() => {
                        setdownloaddata(0);
                        setisProgressClicked(true);
                        fileDownload();
                      }}
                      type="primary"
                      shape="round"
                      size="large"
                      className="download-btn-styles"
                    >
                      <div style={{ marginTop: "-7px" }}>Download</div>
                      <div
                        style={{
                          fontSize: "11px",
                          lineHeight: "7px",
                          color: "#b4c8dc",
                        }}
                      >
                        .xls report
                      </div>
                    </Button>
                  )}
                </div>
              </div>
            ) : null;
          }} */
          />
        </div>
      ) : (
        <Alert
          style={{ margin: "10px" }}
          message="Informational Notes"
          description="The data for the selected time period is too big."
          type="info"
          showIcon
        />
      )}
    </div>
  );
};
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setSelectedBranchIndex: (index: number) =>
      dispatch(setSelectedBranch(index)),
  };
};
const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  crops: selectCrops,
  branches: selectBranches,
  selectedCropId: selectSelectedCrop,
  selectedBranch: selectSelectedBranch,
  varietiesList: selectVarieties,
  currentpage: selectCurrentPage,
  viewAuctionPage: selectViewAuctionPage,
  hubs: selectHubs,
  branchParams: selectBranchParams,
  authData: selectAuthData,
});

export default connect(mapStateToProps, mapDispatchToProps)(IntermediateScreen);
